<news-article [newsItem]="newsItem" [promotedProduct]="promotedProduct"></news-article>